import React, { useEffect, useRef, useState } from "react";
import { useSchoolDetailsContext } from "../context/SchoolDetailsContext";
import { useLocation, useNavigate } from "react-router-dom";
import { combineDataForSearch } from "../pages/SearchPage";
import { useAllDataContext } from "../context/AllDataContext";
import useTab from "../hooks/useTab";

const MobileSearch = ({ scroll }) => {
  const formRef = useRef(null);
  const tab = useTab();
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [showSearchForm, setShowSearchForm] = useState(false);
  const { schoolDetailsData } = useSchoolDetailsContext();
  const { allData } = useAllDataContext();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);

  useEffect(() => {
    if (searchQuery.trim().length === 0) {
      setSuggestions([]);
      return;
    }

    const lowerQuery = searchQuery.toLowerCase();
    const filtered = combineDataForSearch(allData).filter((item) =>
      Object.values(item).some(
        (val) =>
          typeof val === "string" && val.toLowerCase().includes(lowerQuery)
      )
    );

    setSuggestions(filtered);
  }, [searchQuery, allData]);
  const staticDataMap = {
    email: schoolDetailsData[0]?.attributes?.Email,
    address: schoolDetailsData[0]?.attributes?.Address,
    phone: `${schoolDetailsData[0]?.attributes?.Phone_Number1 || ""}, ${
      schoolDetailsData[0]?.attributes?.Phone_Number2 || ""
    }`,
  };

  const staticLabelMap = {
    email: "Email",
    address: "Address",
    phone: "Phone Number",
    admission: "Admission Enquiry",
  };
  const staticKeys = ["email", "address", "phone", "admission"];
  const lowerQuery = searchQuery.toLowerCase();

  const matchedKey = staticKeys.find(
    (key) =>
      key.includes(lowerQuery) ||
      staticLabelMap[key].toLowerCase().includes(lowerQuery)
  );
  const isStaticMatch = Boolean(matchedKey);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?query=${encodeURIComponent(searchQuery.trim())}`);
      setSuggestions([]);
    }
  };

  const handleSuggestionClick = (section, path, id) => {
    // setSearchQuery(title);
    // navigate(`/search?query=${encodeURIComponent(title)}`);
    // setSuggestions([]);
    if (
      section === "studentlife" ||
      section === "faculty" ||
      section === "gallery" ||
      section === "tiles" ||
      section === "objective"
    ) {
      navigate(path, {
        state: { section: `${section}${id}` },
      });
    } else {
      navigate(path, {
        state: { section: section },
      });
    }
    setSuggestions([]);
    setShowSearchForm(false);
    setSearchQuery("");
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (formRef.current && !formRef.current.contains(event.target)) {
        setIsInputFocused(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <>
      <button
        type="button"
        className="search-mobile d-lg-none text-neutral-200 flex-center"
        onClick={() => setShowSearchForm((prev) => !prev)}
      >
        {showSearchForm ? (
          <i className={`ph ph-x ${scroll && "text-white"}`} />
        ) : (
          <i
            className={`ph-bold ph-magnifying-glass ${scroll && "text-white"}`}
          />
        )}
      </button>
      <form
        ref={formRef}
        onSubmit={handleSubmit}
        className={`search-mobile-form position-absolute ${
          tab ? "w-50" : "w-95"
        } d-lg-none ${showSearchForm ? "show" : ""}`}
        style={{ left: !tab ? "calc(var(--bs-gutter-x) * 0.5)" : "unset" }}
      >
        <input
          type="text"
          className="common-input rounded-pill bg-main-25 pe-48 border-neutral-30"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          onFocus={() => setIsInputFocused(true)}
          style={{ padding: "10px 18px" }}
        />
        <button
          type="submit"
          className="w-32 h-32 bg-main-600 hover-bg-main-700 rounded-circle flex-center text-md text-white position-absolute top-50 translate-middle-y inset-inline-end-0 me-8"
        >
          <i className="ph-bold ph-magnifying-glass" />
        </button>
        {(suggestions.length > 0 || isStaticMatch) &&
          searchQuery !== "" &&
          isInputFocused && (
            <ul className="suggestion-dropdown position-absolute bg-white border rounded shadow mt-2 w-100 z-10">
              {isStaticMatch && (
                <li
                  onClick={() => {
                    handleSuggestionClick(
                      matchedKey === "admission"
                        ? "admissioninfo"
                        : "contactinfo",
                      matchedKey === "admission"
                        ? "/admission"
                        : location.pathname
                    );
                    setSearchQuery("");
                  }}
                  className="px-3 py-2 cursor-pointer hover-bg-main-50"
                  style={{ cursor: "pointer" }}
                >
                  <h5 className="wow bounceInRight mb-0 text-ellipsis">
                    {staticLabelMap[matchedKey] || ""}
                  </h5>
                  <p className="text-neutral-500 text-line-2 wow bounceInUp text-ellipsis">
                    {staticDataMap[matchedKey] || ""}
                  </p>
                </li>
              )}
              {suggestions.map((item, index) => (
                // <li
                //   key={index}
                //   onClick={() =>
                //     handleSuggestionClick(item.Title || item.Name || "")
                //   }
                //   className="px-3 py-2 cursor-pointer hover-bg-main-50"
                //   style={{ cursor: "pointer" }}
                // >
                //   {item.Title || item.Name}
                // </li>
                <li
                  key={index}
                  onClick={() =>
                    handleSuggestionClick(item.section, item.path, item.id)
                  }
                  className="px-3 py-2 cursor-pointer hover-bg-main-50"
                  style={{ cursor: "pointer" }}
                >
                  {item.Snippet && (
                    <div className="flex-align d-inline-flex gap-8 mb-16 wow bounceInDown">
                      <h6 className="text-main-600 mb-0 text-ellipsis">
                        {item.Snippet}
                      </h6>
                    </div>
                  )}
                  {(item.Title || item.Name) && (
                    <h5 className="wow bounceInRight mb-0 text-ellipsis">
                      {item.Title || item.Name || ""}
                    </h5>
                  )}
                  {item.Description && (
                    <p
                      className="text-neutral-500 text-line-2 wow bounceInUp text-ellipsis"
                    >
                      {item.Description.replace(/<[^>]*>/g, '').replace(/[-*_]/g, '')}
                    </p>
                  )}
                  {(item.Position || item.Role) && (
                    <p className="text-neutral-500 text-line-2 wow bounceInUp text-ellipsis">
                      {item.Position || item.Role || ""}
                    </p>
                  )}
                  {item.Email && (
                    <p className="text-neutral-500 text-line-2 wow bounceInUp text-ellipsis">
                      {item.Email || ""}
                    </p>
                  )}
                  {item.Phone_Number && (
                    <p className="text-neutral-500 text-line-2 wow bounceInUp text-ellipsis">
                      {item.Phone_Number || ""}
                    </p>
                  )}
                </li>
              ))}
            </ul>
          )}
      </form>
    </>
  );
};

export default MobileSearch;
